import { render, staticRenderFns } from "./FlowEventHistory.vue?vue&type=template&id=4a210ed0"
import script from "./FlowEventHistory.vue?vue&type=script&lang=js"
export * from "./FlowEventHistory.vue?vue&type=script&lang=js"
import style0 from "./FlowEventHistory.vue?vue&type=style&index=0&id=4a210ed0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports